export default "assets/images/icons/guillemet-e4e179d1.svg";